const createPostContributorDialogSlice = (set) => ({
  postContributorDialog: {
    post: null,
    open: false,
    postType: null,
    type: null,
    comment: null,
    showDialog: (post, postType, type, comment = null) => {
      set((state) => ({
        postContributorDialog: {
          ...state.postContributorDialog,
          post: post,
          open: true,
          postType: postType,
          type: type,
          comment: comment,
        },
      }));
    },
    hideDialog: () => {
      set((state) => ({
        postContributorDialog: {
          ...state.postContributorDialog,
          post: null,
          open: false,
          postType: null,
          type: null,
        },
      }));
    },
  },
});

export default createPostContributorDialogSlice;
